import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles, Users } from "lucide-react";
import { useBetaStatus } from "@/hooks/useBetaStatus";

/** Phase 12 — sitewide public BETA banner. Intentional and exciting, never alarming.
 * Clearly separates BETA (explore/test/sign up) from the official implementation. */
export const BetaBanner = () => {
  const beta = useBetaStatus();
  if (!beta?.beta_mode || !beta?.banner_enabled) return null;
  const msg = beta.messaging || {};
  return (
    <div className="bg-primary text-white border-b border-primary/50" role="region"
         aria-label="WitnessYourVote beta announcement" data-testid="beta-banner">
      <div className="wyv-container py-2.5">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 text-white text-[10px] font-bold tracking-widest px-2.5 py-0.5 shrink-0">
            <Sparkles className="h-3 w-3" /> BETA
          </span>
          <div className="min-w-0 flex-1 basis-52">
            <p className="font-heading font-bold text-xs sm:text-sm leading-tight" data-testid="beta-banner-title">
              <span className="hidden sm:inline">{msg.banner_title || "WITNESSYOURVOTE IS NOW IN BETA"}</span>
              <span className="sm:hidden">{msg.mobile_title || "WE'RE IN BETA"}</span>
            </p>
            <p className="text-[11px] text-blue-100 leading-snug hidden md:block" data-testid="beta-banner-body">
              {msg.banner_body}
            </p>
            <p className="text-[11px] text-blue-100 leading-snug md:hidden">
              {msg.mobile_body || "Explore WitnessYourVote today. Sign up to know when the full platform goes live."}
            </p>
            {beta.counter && (
              <p className="text-[10px] text-emerald-300 mt-0.5 inline-flex items-center gap-1" data-testid="beta-banner-counter">
                <Users className="h-3 w-3" /> Join {beta.counter} {beta.counter === 1 ? "person" : "people"} following the WitnessYourVote launch
              </p>
            )}
          </div>
          <div className="flex flex-wrap gap-2 shrink-0">
            <Button asChild size="sm" className="bg-emerald-500 hover:bg-emerald-600 text-white h-8 text-xs font-bold"
                    data-testid="beta-banner-cta">
              <Link to="/beta#signup">{msg.banner_cta || "GET ON THE LIST"}</Link>
            </Button>
            <Button asChild size="sm" variant="outline"
                    className="bg-transparent border-white/40 text-white hover:bg-white/10 hover:text-white h-8 text-xs"
                    data-testid="beta-banner-learn">
              <Link to="/beta">{msg.banner_secondary || "LEARN HOW IT WORKS"}</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
